module.exports = __webpack_public_path__ + "static/img/ruzhu-08.e05b1543.png";